<!--
 * @Author: your name
 * @Date: 2020-02-18 17:12:41
 * @LastEditTime: 2020-11-06 12:39:39
 * @LastEditors: OBKoro1
 * @Description: In User Settings Edit
 * @FilePath: /xkxy_front/src/components/ListShow.vue
 -->
<template>

  <div class="listShow2">
      清除缓存
  </div>
</template>

<script>
import Cookies from 'js-cookie'

export default {
  name: 'Clear',
  data() {
    return {
        
    }   
  },

  methods: {
    
  },
  mounted: function () {
      Cookies.remove('openid')
      Cookies.remove('uid')
      Cookies.remove('openid3')
      Cookies.remove('uid3')
      Cookies.remove('city')
      Cookies.remove('province')
      Cookies.remove('nickname')
      Cookies.remove('sex')
  }
}
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// src/components/Clear.vue